import { Directive, input, output } from '@angular/core';

@Directive({
  exportAs: 'idealsClipboard',
  host: {
    '(click)': 'copyToClipboard()',
  },
  selector: '[idealsClipboard]',
})
export class ClipboardDirective {
  readonly value = input.required<string>({ alias: 'idealsClipboard' });

  readonly clipboardCopy = output<string>();
  readonly clipboardError = output<Error>();

  copyToClipboard(): void {
    this.#copy(this.value())
      .then((value) => this.clipboardCopy.emit(value as string))
      .catch((e: Error) => this.clipboardError.emit(e));
  }

  #copy(value: string): Promise<string | Error> {
    return new Promise((resolve, reject): void => {
      if (navigator.clipboard !== undefined) {
        navigator.clipboard.writeText(value)
          .then(() => resolve(value))
          .catch(reject);
      }
    });
  }
}
